<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_environmental_tool_used" name="is_environmental_tool_used" rules="" v-slot="{ errors }">
              <small class="label">5.1 Do you use ISO 14001 as an environmental tool?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_environmental_tool_used" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider  v-if="form.is_environmental_tool_used" vid="is_environmental_tool_used_text" name="is_environmental_tool_used_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_environmental_tool_used_text" class="w-full" v-model="form.is_environmental_tool_used_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_environmental_accredit" name="is_environmental_accredit" rules="" v-slot="{ errors }">
              <small class="label">Are you accredited, or do you have plans to become accredited?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_environmental_accredit" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_environmental_accredit" vid="is_environmental_accredit_text" name="is_environmental_accredit_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_environmental_accredit_text" class="w-full" v-model="form.is_environmental_accredit_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="responsible_environmental" name="responsible_environmental" rules="required" v-slot="{ errors }">
              <small class="label">5.2 Who is responsible for the site environmental management?</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="responsible_environmental" class="w-full" v-model="form.responsible_environmental" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
          <ValidationProvider vid="is_environmental_policy" name="is_environmental_policy" rules="" v-slot="{ errors }">
              <small class="label">5.3 Do you have a Environmental Policy?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_environmental_policy" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_environmental_policy" vid="is_environmental_policy_reviewed" name="is_environmental_policy_reviewed" rules="required" v-slot="{ errors }">
              <small class="label">When was your environmental policy last reviewed?</small>
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" type="date" name="is_environmental_policy_reviewed" class="w-full" v-model="form.is_environmental_policy_reviewed" :danger="errors[0]" :danger-text="errors[0]" />-->
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="form.is_environmental_policy_reviewed"
                placeholder="Choose Date"
              />
              <span  class="text-danger text-sm">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_environmental_policy" vid="enviromental_policy_file" name="enviromental_policy_file" rules="" v-slot="{ errors }">
              <small class="label">Policy file</small>
              <a target="_blank" v-if="form.enviromental_policy_file" class="float-right" :href="form.is_environmental_policy_file">view file</a>
              <vs-input :disabled="__isDisabledRawMaterial(status)" @change="onUploadPolicyFile($event)" type="file" name="is_environmental_policy_file" class="w-full" />    <!-- enviromental_policy_file -->
              <span v-if="formUploadRequired" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_environmental_complete === 1"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "SupplierManufacturingEnvironmentDetails",
    data() {
      return {
        form: {
          is_environmental_tool_used: false,
          is_environmental_accredit: false,
          is_environmental_policy: false
        },
        id: null,
        status: {},
        formUploadRequired: false
      }
    },
    components: {
      flatPickr
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_environmental_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (this.form.is_environmental_policy && !this.form.is_environmental_policy_file) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.UpdateManufactureEnvironmentDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture Environment Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onClickCreate() {
        if (this.form.is_environmental_policy && !this.form.is_environmental_policy_file) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufactureEnvironmentDetails(this.form))
            this.showSuccessMessage('Manufacture Environment Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureEnvironmentDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadPolicyFile(event, model_name) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_environmental_policy_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_environmental_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
